import actions from './actions'

const initialState = {
  messageMenu: [],
  fundGrowthMenu: [],
}

export default function dropDownReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_MENU:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
